import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";

export default function AddTestimonial() {
  const [testimonials, setTestimonials] = useState([]);
  const [form, setForm] = useState({
    name: "",
    review: "",
    stars: 5,
    profile: ""
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const res = await axios.get(`${baseurl}getAllTestimonials`);
      setTestimonials(res.data);
    } catch (err) {
      console.error("Failed to fetch testimonials", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.post(`${baseurl}updateTestimonialById/${editingId}`, form);
        Swal.fire("Updated!", "Testimonial updated successfully", "success");
      } else {
        await axios.post(`${baseurl}addTestimonial`, form);
        Swal.fire("Added!", "Testimonial added successfully", "success");
      }
      setForm({ name: "", review: "", stars: 5, profile: "" });
      setEditingId(null);
      fetchTestimonials();
    } catch (err) {
      console.error("Error saving testimonial", err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const handleEdit = (testimonial) => {
    setForm({
      name: testimonial.name,
      review: testimonial.review,
      stars: testimonial.stars,
      profile: testimonial.profile ?? ""
    });
    setEditingId(testimonial.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this testimonial?")) return;
    try {
      await axios.delete(`${baseurl}deleteTestimonialById/${id}`);
      fetchTestimonials();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const columns = [
    { name: "Name", selector: row => row.name, sortable: true },
    { name: "Profile", selector: row => row.profile ?? "-" },
    { name: "Stars", selector: row => "⭐".repeat(row.stars) },
    { name: "Review", selector: row => (row.review?.length > 50 ? row.review.slice(0, 50) + "..." : row.review) },
    {
      name: "Actions",
      cell: row => (
        <>
          <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(row)}>Edit</button>
          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row.id)}>Delete</button>
        </>
      ),
    }
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        
        <AdminTopbar />


        <div className="p-3 bg-white mb-3">
<h4 className="mb-3 text-start">Manage Testimonials</h4>

        <form onSubmit={handleSubmit} className="mb-4">
          <div className="row">
            <div className="col-md-4 mb-2">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Enter Name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4 mb-2">
              <input
                type="text"
                name="profile"
                className="form-control"
                placeholder="Enter Profile/Designation"
                value={form.profile}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4 mb-2">
              <input
                type="number"
                name="stars"
                className="form-control"
                placeholder="Stars (1-5)"
                value={form.stars}
                min={1}
                max={5}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12 mb-2">
              <textarea
                name="review"
                className="form-control"
                placeholder="Enter Review"
                value={form.review}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12 text-end">
              <button className="btn btn-primary" type="submit">
                {editingId ? "Update" : "Add"} Testimonial
              </button>
            </div>
          </div>
        </form>
        </div>
        

        <table className="custom-table">
  <thead>
    <tr>
      <th>Name</th>
      <th>Profile</th>
      <th>Stars</th>
      <th>Review</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {testimonials.map((row) => (
      <tr key={row.id}>
        <td>{row.name}</td>
        <td>{row.profile}</td>
         
        <td>{"⭐".repeat(row.stars)}</td>
        <td>{row.review?.length > 50 ? row.review.slice(0, 50) + "..." : row.review}</td>
        <td>
          <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(row)}>
            Edit
          </button>
          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row.id)}>
            Delete
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>

      </div>
    </div>
  );
}
